import * as React from 'react';
const SvgArrowRight = (props) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width={20}
        height={20}
        fill='none'
        {...props}>

        <g>
            <path
                fill='currentColor'
                d='M13.51 10.541H4.96a.53.53 0 0 1-.543-.537q0-.23.156-.387a.52.52 0 0 1 .386-.16h8.55l-2.034-2.034a.56.56 0 0 1-.174-.383.52.52 0 0 1 .163-.391.55.55 0 0 1 .393-.17q.21.004.384.178l2.885 2.885a.63.63 0 0 1 .185.453.6.6 0 0 1-.048.25.8.8 0 0 1-.144.22l-2.878 2.877a.5.5 0 0 1-.369.163.57.57 0 0 1-.387-.175.52.52 0 0 1-.167-.387.55.55 0 0 1 .177-.387z'
            />
        </g>
    </svg>
);
export default SvgArrowRight;
